import React, { useContext, useEffect, useState } from 'react'

import { SocketContext } from '../context/SocketContext'

import { SelectElement } from './selectElement'
import LoadingOverlay from './LoadingOverlay'

export const UsuariosPermisos = ( { uidUsuario, usuario }  ) => {
    
    const { socket } = useContext( SocketContext );

    const [ isLoading, setIsLoading ] = useState(false);
    const [ usuarioSeleccionado, setUsuarioSeleccionado ] = useState(uidUsuario);
    const [ usuarios, setUsuarios ] = useState('');
    const [ roles, setRoles ] = useState([]);

    const entidad = usuario.entidad;

    const datos={
        entidad
    }


    useEffect(() => {

        socket.on('usuario-roles', ( lista ) => {
            setRoles( lista )
        })

        return () => {
            socket.off('usuario-roles')
        }


    }, [socket]);

    useEffect(() => {

        
        // async function fetchAtenciones() {
            // setIsLoading(true) 
            console.log(usuarioSeleccionado)
            datos.uidUsuarioSeleccionado= usuarioSeleccionado
            
            setIsLoading(true)
            socket.emit('usuario-roles', datos, ( lista ) => {
                setIsLoading(false)
                
                console.log(lista)
                setRoles( lista )
                // setIsLoading(false) 
            })
        // }

        // fetchAtenciones();


        return () => {
            socket.off('usuario-roles')
        }


    }, [usuarioSeleccionado]);


    const handleChecked = (checked, i) => {

        console.log(usuarioSeleccionado)
        if (usuarioSeleccionado === '' ) return false;

        let tmp = roles[i];
        tmp.checked = !checked;
        // let rolesClone = [...roles];
        // rolesClone[i] = tmp;
        // setRoles([...rolesClone]);
        
        const data= {
            entidad,
            uidUsuario: usuario.uidUsuario,
            uidRol: roles[i].uidRol, 
            uidUsuarioSeleccionado: roles[i].uidUsuarioSeleccionado, 
            checked: tmp.checked
        }
        
        setIsLoading(true) 
        socket.emit('edita-usuario-rol', data, ( res ) => {
            setIsLoading(false) 
            console.log(res)

        })
        
    }

    useEffect(() => {
        async function fetchUsuarios() {

            setIsLoading(true)
            await socket.emit('select-Usuarios', datos, ( lista ) => {
                setIsLoading(false)
                const opciones = lista.map( (item) => ( { value: item.uidUsuario, label: item.nombreCompleto.toUpperCase() } ) )
                setUsuarios( opciones )
                
            })
        }

        fetchUsuarios();
               
        return () => {
            socket.off('select-Usuarios')
        }
    }, [socket ])

  return (
    <>
        {isLoading && <LoadingOverlay />}
        
        <div className={`content ${isLoading ? 'opacity' : ''} m-5`}>

            <div className='row'>
                <div className='form-group col-lg-4 col-12'>
                                
                    <label> Usuarios </label>
                    <SelectElement
                        options= { usuarios }
                        name={"uidUsuario"}
                        isMulti= {false}
                        closeOnMenuSelect= {true}
                        onChange= {(ev) => setUsuarioSeleccionado(ev ? ev.value : "") }
                        classname= "" 
                        seleccionado= {usuarioSeleccionado}
                        isClearable = {true}
                    />
                </div>

                <div className='form-group col-lg-8 col-12 rounded shadow p-3'>
                                
                    
                    <div className='col-12 '>
                        <table className='table table-responsive table-striped max600' width={'100%'}  >
                            <thead>
                                <tr>
                                    <th width={'5%'}></th>
                                    <th width={'95%'}>Roles</th>
                                </tr>
                            </thead>
                            <tbody width={'100%'} >
                                {roles.map((item, i) => (

                                    <tr key={item.uidRol}>
                                        <td width={'5%'}>
                                    
                                            <div className="form-check form-switch">
                                            {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                                                <input 
                                                    className="form-check-input" 
                                                    checked= {item.checked } 
                                                    type="checkbox" 
                                                    id={`chkAsignado_${item.uidRol}`} 
                                                    onChange={() => handleChecked(item.checked, i)  }
                                                    

                                                
                                                />

                                                <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                            </div>


                                        </td>
                                        <td width={'95%'}> 
                                            {item.rol.toUpperCase()}
                                        </td>
                                    
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    
                    
                </div>
            
            
            </div>

        </div>
    </>


  )
}
